module.exports = __webpack_public_path__ + "static/img/3.7a4d640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newThree/3.png
// module id = ydyK
// module chunks = 0